import invariant from 'tiny-invariant';
import { PlanDiffResponse } from '../diff';
import { PlanStore } from './plan';

type DiffKey = keyof PlanDiffResponse;
type UpsertItem<K extends DiffKey> = NonNullable<NonNullable<PlanDiffResponse[K]>['upsert']>[number];

export function getCreatedItems<K extends DiffKey>(
  key: K,
  response: PlanDiffResponse,
  prevState: PlanStore,
): UpsertItem<K>[] {
  const upserted = response[key]?.upsert ?? [];
  const existingIds = new Set(Object.keys(prevState[key] || {}).map(Number));

  return upserted.filter((item) => !existingIds.has(item.id));
}

export function getSingleCreatedItem<K extends DiffKey>(
  key: K,
  response: PlanDiffResponse,
  prevState: PlanStore,
): UpsertItem<K> {
  const created = getCreatedItems(key, response, prevState);
  invariant(created.length === 1, `Expected exactly 1 new item in ${key}, but got ${created.length}`);
  return created[0];
}
